import { AxiosBO } from "./axios-bo";

const checkLinkURL = () => {
   if(window.location.href.includes("https://vtrcbackoffice.redcross.or.th/")){
		return "https://uat-vtrcapi.redcross.or.th/"
	}else if(window.location.href.includes("https://uat-vtrcbackoffice.redcross.or.th/")){
		// return "https://vtrcapi.redcross.or.th/api/graphql"
		// return "https://vtrcapi.redcross.or.th/backup-site/graphql"
		return "https://uat-vtrcapi.redcross.or.th/"
	}else if(window.location.href.includes("http://localhost:3000/") || window.location.href.includes("http://localhost:3001/")){
		// return "http://192.168.0.162:8081/api/graphql"
		// return "http://10.188.128.162:8081/api-uat/graphql"
		// return "https://vtrcapi.redcross.or.th/api/graphql"
		// return "https://vtrcapi.redcross.or.th/backup-site/graphql"
		return "https://uat-vtrcapi.redcross.or.th/"
	}
}

export default AxiosBO(checkLinkURL())

